import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress, Stack } from "@mui/material";
var LoadingView = function () {
    return (_jsx(Stack, { sx: { minHeight: "100px" }, justifyContent: "center", alignItems: "center", children: _jsx(CircularProgress, {}) }));
};
export default LoadingView;
